var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { View } from "./view";
import { PropertiesHeader } from "./header";
import { PROPERTY_ENTITIES } from "./data";
import LocalStorageService from "../../services/localStorage";
import showToast from "../../services/toast";
import { showErrorToast } from "../../fnx/showError";
import { usePropertyEntitiesGetAll } from "../../fnx/properties/propertyEntitiesGetAll";
import { usePropertiesGetAll } from "../../fnx/properties/propertiesGetAll";
import { usePropertiesMutations } from "../../fnx/properties/propertiesMutations";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
/* Flags de la página. CAN_DELETE debe quedar en false mientras el endpoint
   DELETE /V1/Properties/{id} no exista. SHOW_ENDPOINT y SHOW_PAYLOAD_PREVIEW
   son herramientas de QA: van apagadas en producción. */
var CAN_CREATE = true;
var CAN_EDIT = true;
var CAN_DELETE = false;
var SHOW_TARGET_ID = true;
var SHOW_ENDPOINT = false;
var SHOW_PAYLOAD_PREVIEW = false;
/**
 * Administración de properties por entidad (/V1/Properties).
 *
 * PropertiesAFY es presentacional: solo maneja estado de UI. Este contenedor
 * trae los datos, recibe los callbacks y recarga el listado después de cada
 * POST / PATCH / DELETE, porque la página nunca modifica su propia lista.
 */
export var PropertiesAdmin = function () {
    var _a;
    var t = useTranslation().t;
    var clientId = useState(((_a = lsLogin.getUserLoginStored()) === null || _a === void 0 ? void 0 : _a.clientId) || "")[0];
    var _b = useState(false), trigger = _b[0], setTrigger = _b[1];
    var _c = useState({
        entityName: PROPERTY_ENTITIES[0].entityName,
    }), selection = _c[0], setSelection = _c[1];
    var _d = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _d[0], setSeeToast = _d[1];
    /* 1 · Registros de cada entidad: los cinco GET en paralelo, una sola vez. */
    var _e = usePropertyEntitiesGetAll(trigger, PROPERTY_ENTITIES, clientId), responsePropertyEntities = _e.responsePropertyEntities, errorPropertyEntities = _e.errorPropertyEntities, loadingPropertyEntities = _e.loadingPropertyEntities;
    /* 2 · Properties de la categoría activa, disparadas por onChangeSelection. */
    var _f = usePropertiesGetAll(selection.entityName), responseProperties = _f.responseProperties, errorProperties = _f.errorProperties, loadingProperties = _f.loadingProperties, getPropertiesByEntity = _f.getPropertiesByEntity;
    /* 3 · Mutaciones. */
    var _g = usePropertiesMutations(), createProperty = _g.createProperty, updateProperty = _g.updateProperty, removeProperty = _g.removeProperty, clearPropertyMutation = _g.clearPropertyMutation, loadingPropertyMutation = _g.loadingPropertyMutation, responsePropertyMutation = _g.responsePropertyMutation, errorPropertyMutation = _g.errorPropertyMutation;
    useEffect(function () {
        setTrigger(true);
    }, []);
    /* Un cambio de categoría vuelve a pedir el listado; un cambio de registro no,
       porque la página filtra por entityId sobre la lista completa. */
    var handleChangeSelection = function (newSelection) {
        setSelection(newSelection);
    };
    var refresh = function () { return getPropertiesByEntity(selection.entityName); };
    var handleCreateProperty = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var ok;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createProperty(payload)];
                case 1:
                    ok = _a.sent();
                    if (ok)
                        refresh();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateProperty = function (property, payload) { return __awaiter(void 0, void 0, void 0, function () {
        var ok;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateProperty(property, payload)];
                case 1:
                    ok = _a.sent();
                    if (ok)
                        refresh();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteProperty = function (property) { return __awaiter(void 0, void 0, void 0, function () {
        var ok;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, removeProperty(property)];
                case 1:
                    ok = _a.sent();
                    if (ok)
                        refresh();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!responsePropertyMutation)
            return;
        var messages = {
            create: "Property creada con éxito",
            update: "Property actualizada con éxito",
            delete: "Property eliminada con éxito",
        };
        setSeeToast({
            show: true,
            message: messages[responsePropertyMutation],
            type: typeAlert.success,
        });
        clearPropertyMutation();
    }, [responsePropertyMutation]);
    useEffect(function () {
        if (errorPropertyEntities) {
            showErrorToast(errorPropertyEntities, setSeeToast, t);
        }
    }, [errorPropertyEntities]);
    useEffect(function () {
        if (errorProperties) {
            showErrorToast(errorProperties, setSeeToast, t);
        }
    }, [errorProperties]);
    useEffect(function () {
        if (errorPropertyMutation) {
            showErrorToast(errorPropertyMutation, setSeeToast, t);
            clearPropertyMutation();
        }
    }, [errorPropertyMutation]);
    /* El loader de pantalla completa cubre lo que deja la página inutilizable:
       la carga inicial de categorías y las mutaciones. El fetch del listado usa
       el loading propio de PropertiesAFY, que reemplaza solo la tabla y deja los
       chips y el listado de registros usables. */
    var blockingLoading = loadingPropertyEntities || loadingPropertyMutation;
    return (_jsxs(React.Fragment, { children: [_jsx(PropertiesHeader, { loading: blockingLoading, textLoading: loadingPropertyMutation ? "Guardando..." : "Cargando propiedades...", seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast }), _jsx(View, { title: "Gesti\u00F3n de properties", description: "Propiedades configurables por entidad.", categories: responsePropertyEntities, properties: responseProperties, selectedEntityName: selection.entityName, selectedEntityId: selection.entityId, loading: loadingProperties, canCreate: CAN_CREATE, canEdit: CAN_EDIT, canDelete: CAN_DELETE, showTargetId: SHOW_TARGET_ID, showEndpoint: SHOW_ENDPOINT, showPayloadPreview: SHOW_PAYLOAD_PREVIEW, onChangeSelection: handleChangeSelection, onCreateProperty: handleCreateProperty, onUpdateProperty: handleUpdateProperty, onDeleteProperty: handleDeleteProperty })] }));
};
export default PropertiesAdmin;
